import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "greek1",
  width: "100%",
  height: "100%",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("pattern", {
        id: "greek_a1",
        patternUnits: "userSpaceOnUse",
        width: "62",
        height: "68",
        patternTransform: "scale(1.5) rotate(0)"
      }, [
        _createElementVNode("rect", {
          x: "0",
          y: "0",
          width: "100%",
          height: "100%",
          fill: "transparent"
        }),
        _createElementVNode("path", {
          d: "M41.845 51.072h3.465v-7.035h-7.076v13.999H52.18V37.21H31.117m0 27.79V37.21M20.389 51.07h-3.466v-7.034H24v13.999H10.055V37.21h21.062m10.728-20.283h3.465v7.035h-7.076V9.964H52.18V30.79H31.117m0-27.789v27.79M20.389 16.927h-3.466v7.035H24V9.964H10.055V30.79h21.062M3 3h56v62H3.126z",
          "stroke-linecap": "square",
          "stroke-width": "1",
          stroke: "currentColor",
          fill: "none"
        })
      ])
    ], -1),
    _createElementVNode("rect", {
      width: "800%",
      height: "800%",
      transform: "translate(0,0)",
      fill: "url(#greek_a1)"
    }, null, -1)
  ])))
}
export default { render: render }